import * as React from "react";
import { Route, Redirect, Switch, withRouter, RouteComponentProps } from "react-router-dom";
import { RouteProps } from "./routes-path";

import pathDetailClena from "./detailni-udaje/routes-path";
import pathPrihlaska from "./prihlaska/routes-path";
import pathOvereniEmailu, { pathOvereniEmailuDeprecated } from "./overeni-emailu/routes-path";

import { DetailClena } from "./detailni-udaje/view";
import Prihlaska from "./prihlaska/Prihlaska";
import { OvereniEmailu } from "./overeni-emailu/view";

class Clenove extends React.PureComponent<RouteComponentProps<RouteProps>, {}> {

    render() {
        const pathRedirect = "/";

        return <Switch>
            <Route path={pathDetailClena} render={(routeProps) => <DetailClena />} />
            <Route path={pathPrihlaska} render={(routeProps) => <Prihlaska />} />
            <Route path={pathOvereniEmailu} exact render={(routeProps) => <OvereniEmailu />} />

            {/* //TODO: v nove verzi odstranit  */}
            <Route path={pathOvereniEmailuDeprecated} exact render={(routeProps) => <OvereniEmailu />} />

            <Redirect to={pathRedirect} />
        </Switch>;

    }
}

export default withRouter(Clenove);